import { signal } from '@angular/core';
import { TCatalogOption } from '../model';

export const yesNoCatalog$$ = signal<TCatalogOption[]>([
  { key: 'כן', value: true },
  { key: 'לא', value: false }
]);
